<div class="container mt-4">
   <div class="col-lg-8 col-md-6 col-sm-12">
  <h1>Terms and Conditions</h1>

  <P>By accessing and using Skybeth Crochet, you agree to these Terms & Conditions.</P> 

   <h3><b>Products</b></h3>
    <p>All products are handmade. Minor variations in size, color, and appearance may occur and are considered part of the unique nature of handmade items.</p>

<h3><b>Pricing</b></h3>

<p>Prices are listed in U.S. Dollars (USD) unless otherwise stated. Prices may change without notice.</p>

 <h3><b>Order Acceptance</b></h3>

<p>We reserve the right to refuse or cancel any order for any reason, including product availability, pricing errors, or suspected fraud.
</p>
<h3><b>Intellectual Property</b></h3>

<p>All website content, photographs, logos, product descriptions, and designs are the property of Skybeth Crochet and may not be copied, reproduced, or distributed without written permission.
</p>
<h3><b>Limitation of Liability</b></h3>
<p>Skybeth Crochet is not responsible for indirect, incidental, or consequential damages resulting from the use of our products or website.</p>

</div>
</div>
